<template>
   <div class="hotel-search-result-wrapper">
      <div class="hotel-search-result-inner">
         <div class="hotel-search-filter-wrapper" v-show="reccommendedList.length > 0 || hotelList.length > 0" v-if="false">
            <HotelFilter :filters="filters" ref="hotelfilter" />
         </div>

         <div class="hotel-search-debugger" v-if="isResultDebugger">
            <SearchResultDebugger
               :duration="$store.state.hotel.searchResultTime"
               :searchListCount="TotalHotelCount"
               :searchUuid="searchUuid"
               :channels="$store.state.hotel.hotelSearchChannels"
               :channelCount="channelMatchCount" />
         </div>
         <div class="hotel-search-result-content">
            <div id="hotel-search-filter-mobile" @click="handlerShowFilters" class="d-lg-none">
               <i class="gts-icon icon-filter icon-sm"></i>
               <span>{{ $t("hotelSearch_btnShowFilter") }}</span>
            </div>

            <div class="hotel-search-count-sorting-container">
               <div class="hotel-search-count">
                  <span> {{ HotelSearchResultTextLabel() }}</span>
                  <div class="filter-search-wrapper">
                     <span>{{ $t("hotelSearch_lblFilterStatus") }}</span>
                     <span :class="filterSearch ? 'active' : 'passive'">{{ filterSearch ? $t("hotelSearch_lblFilterStatusOn") : $t("hotelSearch_lblFilterStatusOff") }}</span>
                     <button v-if="filterSearch" @click="handlerClearAllFilterTrigger">{{ $t("hotelSearch_lblFilterClearAll") }}</button>
                  </div>
               </div>
               <div class="hotel-search-right-container">
                  <div class="gts-direct-button-wrapper" @click="handlerShowOnlyGtsDirect" :class="$store.state.hotel.isOnUsFilterSearch ? 'active' : ''">
                     <span class="gts-direct-flag"></span>
                     <span class="gts-direct-text">{{ $t("hotelSearch_lblOnlyGtsDirect") }}</span>
                  </div>
                  <div class="hotel-search-sorting">
                     <UISelectBox id="select_hotelSorting" :options="options" v-model="selectedDefault" @input="handleSelectFilter" light-theme />
                  </div>
               </div>
            </div>
            <div class="hotel-search-count-sorting-container" v-show="hotelZeroTextVisibility">
               <div class="hotel-search-count">
                  <span>
                     {{ $t("hotelSearch_lblEmptyFilterResult") }}
                  </span>
               </div>
            </div>
            <div class="hotel-search-result-content-inner">
               <!-- {{ reccommendedList }} -->
               <div class="hotel-search-result-list" v-if="reccommendedList.length > 0">
                  <div class="hotel-search-result-list-item" v-for="(recommendedHotelItem, index) in reccommendedList" :key="recommendedHotelItem.id">
                     <HotelCard :index="index" :hotelItem="recommendedHotelItem" isRecommended />
                  </div>
               </div>
               <div class="hotel-search-result-list" v-if="hotelList != '' && !this.$store.state.hotel.hotelFilter.showOnlyRecommendedHotels">
                  <div class="hotel-search-result-list-item" v-for="(hotelItem, index) in hotelList" :key="hotelItem.id">
                     <HotelCard :index="index" :totalHotelCount="hotelList.length" :hotelItem="hotelItem" />
                     <!-- v-if="hotelItem.isShowStatusActive" -->
                  </div>
               </div>
               <UIAlert status="default__light" v-if="hotelListStatus.code == 'EMPTY_LIST'">
                  <p class="w-100 text-center">{{ $t("hotelSearch_lblEmptyHotelList") }}</p>
               </UIAlert>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import HotelCard from "@/components/structural/hotel/search/HotelCard.vue";
import HotelFilter from "@/components/structural/hotel/search/HotelFilters.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import UIAlert from "@/components/unitary/Alert.vue";
import SearchResultDebugger from "@/components/structural/hotel/search/SearchResultDebugger.vue";
// import Filters from "@/helper/filter.js";

export default {
   name: "HotelSearchResultApp",
   props: {
      hotelListProp: Array,
      reccommendedList: Array,
      filterSearch: Boolean,
      totalHotelCount: [String, Number],
      infiniteScroll: Object,
   },

   components: {
      HotelCard,
      HotelFilter,
      UIAlert,
      UISelectBox,
      SearchResultDebugger,
   },
   data() {
      return {
         hotelList: [],
         searchedHotelCount: 0,
         // recommendedHotelList: [],
         hotelsWithPhotos: [],
         hotelsWithoutPhotos: [],
         hotelListStatus: {},
         filters: {},
         hotelZeroTextVisibility: false,
         selectedDefault: "priceincrease",
         isResultDebugger: false,
         hotelSearchChannels: this.$store.state.hotel.hotelSearchChannels,
         searchUuid: this.$store.state.hotel.searchUuid,
         options: [
            { id: 1, name: this.$i18n.t(`common_price_increase`), value: "priceincrease" },
            { id: 2, name: this.$i18n.t(`common_price_decrease`), value: "pricedecrease" },
            { id: 3, name: this.$i18n.t(`common_star_increase`), value: "starincrease" },
            { id: 4, name: this.$i18n.t(`common_star_decrease`), value: "stardecrease" },
         ],
      };
   },
   computed: {
      RecommendedHotelCount() {
         return this.$store.state.hotel.searchResultRecommendedHotel.length;
      },
      NonRecommendedHotelCount() {
         return this.totalHotelCount;
      },
      TotalHotelCount() {
         return this.totalHotelCount;
      },
      channelMatchCount() {
         const channelCount = {};
         Object.values(this.hotelSearchChannels).forEach((channel) => {
            channelCount[channel.channelId] = channel.hotelCount || 0;
         });
         return channelCount;
      },
   },
   created() {
      document.body.addEventListener("keydown", (event) => {
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 80) {
            this.isDebugger = !this.isDebugger;
         }
         if (held && event.keyCode == 84) {
            this.isResultDebugger = !this.isResultDebugger;
         }
      });
   },
   methods: {
      handlerClearAllFilterTrigger() {
         this.$emit("clear-filters", true);
      },
      handlerShowOnlyGtsDirect() {
         this.$emit("is-on-us");
      },
      HotelSearchResultTextLabel() {
         const self = this;
         let listedOtel = self.infiniteScroll.pageCount != self.infiniteScroll.pageIndex ? self.infiniteScroll.pageIndex * this.infiniteScroll.itemPerPage : this.totalHotelCount;
         if (self.TotalHotelCount == 0) {
            return self.$t("hotelSearch_lblNoFoundedHotels");
         } else if (self.RecommendedHotelCount == 0) {
            let fmtValue = self.$t("hotelSearch_lblNonRecommendedHotels");
            return fmtValue.replace("#VALUE1#", self.TotalHotelCount).replace("#VALUE2#", listedOtel);
         } else {
            return self.$t("hotelSearch_lblTotalHotelNumber").replace("#VALUE1#", self.RecommendedHotelCount).replace("#VALUE2#", self.TotalHotelCount).replace("#VALUE3#", listedOtel);
         }
      },
      handlerShowFilters() {
         const hotelFilterMobile = this.$parent.$parent.$refs.hotelFilterMobile;
         hotelFilterMobile.classList.add("mobile-filter-active");
      },
      TotalHotelCountLabel() {
         const self = this;
         if (self.TotalHotelCount == 0) {
            return self.$t("hotelSearch_lblNoFoundedHotels");
         } else if (self.RecommendedHotelCount == 0) {
            return self.$t("hotelSearch_lblNonRecommendedHotels").replace("#VALUE1#", this.TotalHotelCount);
         } else {
            return self.$t("hotelSearch_lblTotalHotelNumber").replace("#VALUE1#", self.RecommendedHotelCount).replace("#VALUE2#", self.TotalHotelCount);
         }
      },
      handlerHasPhotoIdentifier(arr) {
         arr.forEach((item) => {
            if (item.hasPhoto) {
               this.hotelsWithPhotos.push(item);
            } else {
               this.hotelsWithoutPhotos.push(item);
            }
         });
         return;
      },

      //HOTEL SORTING IN ORDER TO PRICE OR STAR
      handlerSortHotels(sortby) {
         switch (sortby) {
            case "priceincrease":
               this.hotelsWithPhotos.sort((a, b) => {
                  if (a.price.amount < b.price.amount) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelsWithoutPhotos.sort((a, b) => {
                  if (a.price.amount < b.price.amount) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelList = this.hotelsWithPhotos.concat(this.hotelsWithoutPhotos);
               this.reccommendedList.sort((a, b) => {
                  if (a.hasPhoto) {
                     if (a.price.amount < b.price.amount) {
                        return -1;
                     } else {
                        return 1;
                     }
                  }
               });
               break;
            case "pricedecrease":
               this.hotelsWithPhotos.sort((a, b) => {
                  if (a.price.amount > b.price.amount) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelsWithoutPhotos.sort((a, b) => {
                  if (a.price.amount > b.price.amount) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelList = this.hotelsWithPhotos.concat(this.hotelsWithoutPhotos);
               this.reccommendedList.sort((a, b) => {
                  if (a.hasPhoto) {
                     if (a.price.amount > b.price.amount) {
                        return -1;
                     } else {
                        return 1;
                     }
                  }
               });
               break;
            case "starincrease":
               this.hotelsWithPhotos.sort((a, b) => {
                  if (a.score.star < b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelsWithoutPhotos.sort((a, b) => {
                  if (a.score.star < b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelList = this.hotelsWithPhotos.concat(this.hotelsWithoutPhotos);
               this.reccommendedList.sort((a, b) => {
                  if (a.score.star < b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               break;
            case "stardecrease":
               this.hotelsWithPhotos.sort((a, b) => {
                  if (a.score.star > b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelsWithoutPhotos.sort((a, b) => {
                  if (a.score.star > b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               this.hotelList = this.hotelsWithPhotos.concat(this.hotelsWithoutPhotos);
               this.reccommendedList.sort((a, b) => {
                  if (a.score.star > b.score.star) {
                     return -1;
                  } else {
                     return 1;
                  }
               });
               break;
         }
      },
      handleSelectFilter(selection) {
         this.handlerSortHotels(selection);
      },
   },
   watch: {
      hotelListProp: {
         handler(hotelList) {
            if (hotelList.length == 0) {
               hotelList = [];
            } else {
               this.hotelList = hotelList;
               this.hotelsWithPhotos = [];
               this.hotelsWithoutPhotos = [];
               this.handlerHasPhotoIdentifier(hotelList);
            }
         },
         immediate: true,
      },
      // "$store.state.hotel.searchResultRecommendedHotel": {
      //    handler(newValue) {
      //       var self = this;
      //       //TODO: Hotel search result will be optimized based on spa logic
      //       if (Object.keys(this.$store.state.hotel.searchResultRecommendedHotel).length == 0) {
      //          self.recommendedHotelList = [];
      //       } else {
      //          self.recommendedHotelList = newValue;
      //       }
      //    },
      //    immediate: true,
      // },
      "$store.state.hotel.searchResultStatus"(newValue) {
         var self = this;
         self.hotelListStatus = newValue;
      },
      "$store.state.hotel.basketResponse"(basketResponse) {
         basketResponse;
         // if (basketResponse == undefined || basketResponse == null) {
         //    return;
         // }
         // this.$parent._data.hotelList = Filters.roomSelectionFilters(this.hotelList, basketResponse.hotelCode, !basketResponse.recommended);
         // this.$parent._data.recommendedHotelList = Filters.roomSelectionFilters(
         //    this.recommendedHotelList,
         //    basketResponse.hotelCode,
         //    basketResponse.recommended
         // );
         // this.$parent.$refs.hotelfilter.runHotelFilters();
      },

      "$store.state.hotel.isFilterActive": {
         handler: function () {
            setTimeout(() => {
               if (document.getElementsByClassName("hotel-card-wrapper").length != 0) {
                  this.hotelZeroTextVisibility = false;
               } else {
                  this.hotelZeroTextVisibility = true;
               }
            }, 10);
         },
         deep: true,
      },
      "$store.state.hotel.hotelFilterSearch": {
         handler: function () {
            setTimeout(() => {
               if (document.getElementsByClassName("hotel-card-wrapper").length != 0) {
                  this.hotelZeroTextVisibility = false;
               } else {
                  this.hotelZeroTextVisibility = true;
               }
            }, 10);
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.hotel-search-result-wrapper {
   width: 100%;
   max-width: 100%;
   transition: 0.3s ease-in-out;

   .hotel-search-result-inner {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .hotel-search-filter-wrapper {
         width: 25%;
         height: 100%;
         background-color: #fff;
         /* box-shadow: 0px 2px 6px var(--gray-1000-alpha-75); */
         box-shadow: var(--gts-box-shadow);
         border-radius: 12px;
         color: var(--gray-700);
      }
      .hotel-search-result-content {
         width: 100%;
         .hotel-search-count-sorting-container {
            display: flex;
            position: relative;
            background: var(--container-bg);
            opacity: 1;
            padding: 1rem 1.5rem;
            margin-bottom: 1.5rem;
            border-radius: 0.5rem;
            align-items: center;
            justify-content: space-between;

            @media (max-width: 576px) {
               margin-top: 1rem;
            }

            .hotel-search-right-container {
               display: flex;
               align-items: center;

               .gts-direct-button-wrapper {
                  display: flex;
                  margin-right: 8px;
                  background: var(--gray-100) 0% 0% no-repeat padding-box;
                  border: 1px solid var(--gray-200);
                  border-radius: 7px;
                  opacity: 1;
                  &:hover {
                     background: var(--gray-200) 0% 0% no-repeat padding-box;
                     cursor: pointer;
                  }
                  &.active {
                     background: var(--blue-500);
                     .gts-direct-text {
                        margin: 8px 8px 8px 4px;
                        color: white;
                     }
                  }
                  .gts-direct-flag {
                     width: 17px;
                     height: 24px;
                     margin: 8px 4px 8px 8px;
                     background-size: 17px 24px;
                     background-image: url("data:image/svg+xml;base64,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");

                     @media (max-width: 576px) {
                        width: 36px;
                     }
                  }
                  .gts-direct-text {
                     margin: 8px 8px 8px 4px;
                  }
               }

               .hotel-search-sorting {
                  ::v-deep {
                     .g-select-box {
                        border-radius: 24rem;
                        min-height: 28px;
                     }
                  }
               }
            }
            .hotel-search-count {
               position: relative;
               font-size: var(--normal);
               font-weight: 500;
            }

            .filter-search-wrapper {
               margin-top: 0.5rem;
               span {
                  font-weight: 500;
                  display: inline-block;
                  color: var(--gray-800);

                  &.active {
                     color: green;
                     margin-left: 0.25rem;
                  }
                  &.passive {
                     color: red;
                     margin-left: 0.25rem;
                  }
               }

               button {
                  background-color: var(--gray-200);
                  color: var(--gray-600);
                  border-radius: 0.5rem;
                  margin-left: 0.5rem;
                  font-weight: 600;
                  padding: 0 0.75rem;

                  &:hover {
                     background-color: var(--gray-800);
                     //color: var(--gray-50);
                     color: var(--gray-0);
                  }
               }
            }
         }
         .hotel-search-result-content-inner {
            .hotel-search-result-list {
               margin-bottom: 1rem;

               &:last-child {
                  margin-bottom: 0;
               }
               .hotel-search-result-list-item {
                  margin-bottom: 1rem;

                  &:last-child {
                     margin-bottom: 0;
                  }
               }
            }

            ::v-deep .gts-alert {
               p {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .gts-icons {
                     display: inline-block;
                     width: 40px;
                     min-width: 40px;
                     max-width: 40px;
                     height: 35px;
                     max-height: 35px;
                     background-size: contain;
                     background-repeat: no-repeat;
                     margin-right: 8px;
                  }
               }
            }
            .hotel-search-result-error {
               background-color: #fff;
               /* box-shadow: 0px 2px 6px var(--gray-1000-alpha-75); */
               box-shadow: var(--gts-box-shadow);
               border-radius: 12px;
               color: var(--gray-700);
            }
         }
         #hotel-search-filter-mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            //background-color: var(--gray-50);
            background-color: var(--gray-0);
            margin: 1rem 0;
            border-radius: 0.5rem;
            padding: 0.5rem;
            cursor: pointer;

            span {
               font-size: var(--large);
               margin-left: 0.5rem;
               font-weight: 500;
            }
         }
      }
   }
}
</style>
